<template>
  <div v-if="!isInitialized">
    <LoadingScreen :caption="'Supply Demand Analysis...'" />
    <SlideYDownTransition>
      <NotConfigured v-if="isNotConfigured" />
    </SlideYDownTransition>
  </div>
  <router-view v-else></router-view>
</template>

<script>
import LoadingScreen from "@/components/modals/LoadingScreen";
import NotConfigured from "@/components/modals/NotConfigured";
import { SlideYDownTransition } from "vue2-transitions";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    LoadingScreen,
    NotConfigured,
    SlideYDownTransition,
  },
  data() {
    return {
      isNotConfigured: false,
    };
  },
  computed: {
    ...mapGetters("SupplyDemand", ["isInitialized"]),
  },
  methods: {
    ...mapActions("SupplyDemand", [
      "fetchConsoles",
      "initializeConsole",
      "reset",
      "fetchCurrentConsoleDetails",
      "fetchPublicConsole",
    ]),
    ...mapActions("Entities", ["fetchStaticEntities", "fetchEntityEvents"]),
    async initialize({ params, queries }) {
      if (queries && queries.id) {
        if (params.mode === "view") {
          this.initializeConsole({
            consoleId: parseInt(queries.id),
            mode: "VIEW",
          });
        } else if (params.mode === "edit") {
          this.initializeConsole({
            consoleId: parseInt(queries.id),
            mode: "EDIT",
          });
        }
      } else {
        this.initializeConsole({ mode: "EDIT" });
      }
    },

    async checkAndPopulateEvents() {
      let entity_events = await this.fetchEntityEvents();

      if (entity_events && entity_events.length > 0) {
        let entityWithEvents = entity_events.find(
          (entity) => entity.supply_demand_meta
        );
        // console.log("entityWithEvents =>", entityWithEvents);
        if (!entityWithEvents) {
          // None of the entities have supply_demand_meta, so analysis is not possible:
          console.error("Entities don't have supply_demand_meta");
          this.isNotConfigured = true;
          return true;
          // this.$router.push("/notconfigured");
        }
      } else {
        // There are zero entities, analysis not possible:
        console.error("There are no Entities, Analysis Not Possible.");
        this.isNotConfigured = true;
        return true;
        // this.$router.push("/notconfigured");
      }
    },

    async loadPrivateConsole({ params, queries }) {
      // Anything that is common for both initializeEditor and initializeViewer do it here:
      const supplyDemandConsoles = await this.fetchConsoles();

      let thereAreConsoles = false;
      if (thereAreConsoles) {
        // if (supplyDemandConsoles && supplyDemandConsoles.length > 0) {
        // If multiple consoles are present(which should not happen), initialize the first console in view mode:
        const firstConsole = supplyDemandConsoles[0];
        // console.log("FirstConsole ", firstConsole);
        await this.fetchCurrentConsoleDetails(firstConsole.id);

        // if (!firstConsole) {
        //   // console.log("Will it every come here?  First time Console");
        //   return this.$router.push("/supply_demand/edit");
        // }

        if (queries.id != firstConsole.id) {
          // If the id doesn't matches firstConsole redirect to first console's view mode:
          this.$router.push(`/supply_demand/view?id=${firstConsole.id}`);
        } else {
          // Else initialize as per request:
          this.initialize({ params, queries });
        }
      } else {
        // Else initialize the edit mode (empty console):
        // TODO: Create layers using the events meta:
        // console.log("Creating layers using Event Meta...");
        // await this.createLayersFromEventsMeta();

        if (!(params.mode === "edit" && !queries.id)) {
          // If the url isn't '/supply_demand/edit change to it:
          this.$router.push("/supply_demand/edit");
        } else {
          // Else initialize as per request (/supply_demand/edit):
          this.initialize({ params, queries });
        }
      }
    },
    async loadPublicConsole({ magic_link }) {
      try {
        const dashboard_details = await this.fetchPublicConsole({ magic_link });

        if (dashboard_details) {
          // await this.checkAndPopulateStaticEntities();

          await this.initializeConsole({
            consoleId: dashboard_details.id,
            mode: "PUBLIC",
          });
        } else {
          this.$router.push("/404");
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
  async mounted() {
    this.reset();
    const params = this.$route.params;
    const queries = this.$route.query;

    // Check whether Supply Demand Analysis is possible or not but fetching the events:
    if (await this.checkAndPopulateEvents()) {
      return;
    }

    if (params.magic_link && params.magic_link.length > 0) {
      this.loadPublicConsole({ magic_link: params.magic_link });
    } else {
      this.loadPrivateConsole({ params, queries });
    }
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      // console.log({ to, from });
      const params = to.params;
      const queries = to.query;

      this.initialize({ params, queries });
    },
  },
};
</script>

<style></style>
